import React from "react"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { useNavigate } from "react-router-dom"
import { AppState } from "store/store"
import { useSelector } from "react-redux"
import { APP_URL } from "Const"
import { buildUrlWithParams } from "utils/BuildUrlWithParams"
import styles from "./GoBackButton.module.scss"

interface Props {
  where?: any
  text?: string
  top?: boolean
  onClick?: () => void
}
/**
 * 前の画面に戻るボタン
 * @param {any}} where - 前の画面へのリンク
 * @param {string} text - ボタン上に表示する文言（デフォルトは「前の画面に戻る」）
 * @param {boolean} top - トップ画面に戻る場合に設定
 * @param {() => void} onClick - ボタン押下時の処理
 */
const GoBackButton = ({ where = APP_URL.TOP, text = "前の画面に戻る", top = false, onClick }: Props) => {
  const navigate = useNavigate()
  const couponCode = useSelector((state: AppState) => state.couponCode.couponCode)
  const cameraOff = useSelector((state: AppState) => state.cameraOff.cameraOff)
  const goHome = () => {
    navigate(buildUrlWithParams(APP_URL.TOP, couponCode, cameraOff))
  }
  return (
    <div
      className={styles.root}
      aria-hidden
      onClick={() => {
        if (top) {
          goHome()
        } else {
          navigate(where)
          if (onClick) {
            onClick()
          }
        }
      }}
    >
      <ArrowBackIcon style={{ color: "#666666" }} />
      <span>{text}</span>
    </div>
  )
}

export default GoBackButton
